module.exports = __webpack_public_path__ + "media/images/vertical-8ccd8fc7192fdc901a7a61bb0766cb56.png";